import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

import OrderTable from '../components/OrderTable'
import OrderPrice from '../components/OrderPrice'

const Order = (props) => {
  let { formControls, formIsValid, product, targetPrice, sendingForm } = props

  let buttonValue = sendingForm ? 'Offerte versturen...' : 'Offerte aanvragen'

  return (
    <div className="c-personalizer-card">

      <div className="c-personalizer-card__header">
        <h3 className="c-personalizer-card__title">Samenvatting</h3>
      </div>

      <div className="c-personalizer-row">
        <p className="c-personalizer-row__title">Overzicht</p>

        { product.id ? ( 
          <div className="c-personalizer-row__order-row u-flex u-flex-sb">
            <div className="c-personalizer-row__order-col c-personalizer-row__order-col--info">
              <OrderTable formControls={formControls} />
            </div>

            <div className="c-personalizer-row__order-col c-personalizer-row__order-col--image">
              { product && product.image ? (
                <div className="c-personalizer-row__order-image u-image" dangerouslySetInnerHTML={{ __html: product.image }} />
              ) : null }
            </div>
          </div>
        ) : (
          <p className="c-personalizer-row__explain">Stel a.u.b. eerst je mat samen.</p>
        ) }

        <OrderPrice targetPrice={targetPrice} />
      </div>

      <div className="c-personalizer-row">
        
        <div className="u-flex u-flex-sb">
          <button type="submit" className="c-personalizer-row__button" disabled={!formIsValid || sendingForm}>{buttonValue}</button>

          { targetPrice === 'Op aanvraag*' ? (
            <p className="c-personalizer-row__order-comment">* Vanwege de specificaties van deze mat is het niet mogelijk een richtprijs aan te geven. Je ontvangt de vrijblijvende prijs na aanvraag.</p>
          ) : null }
        </div>

        { !formIsValid ? (
          <p class="c-personalizer-group__order-error-message">Vul alle verplichte velden in om een offerteaanvraag te kunnen doen.</p>
        ) : null }

      </div>

    </div>
  )
}

export default Order



// WEBPACK FOOTER //
// ./src/js/personalizer/components/Order.js